var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-flexbox__flex']},[_c('iframe',{attrs:{"src":"https://securitynews.sonicwall.com/sonicwall-news/","name":"__embedded_page","frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }